<template>
<div class="main-page">
      <div class="main">
      <div class="main-news" v-if="isSmallScreen===false">
        <p class="main-news-car"><span class="about">About</span> Carbon Cube</p>
        <p class="main-news-gongsi">公司简介 / Company Profile</p>
        <p class="main-news-xiao">探尔科技成立于上海，是具备自主知识产权的高新技术企业，核心团队自2013年开始在气候数字化领</p>
        <p class="main-news-xiao">域深耕，具备强大的硬核技术优势。公司的核心产品“碳立方”已经在发电、建材、石化、化工和钢铁</p>
        <p class="main-news-xiao">等重点控排企业，在建筑、交通和汽车、快消、服装和制药等多个工业产品领域，以及在多个地方政</p>
        <p class="main-news-xiao">府落地实施，为建设中国的绿色产业贡献力量。</p>
      </div>
      <div class="main-news" v-else>
        <p class="main-news-car"><span class="about">About</span> Carbon Cube</p>
        <p class="main-news-gongsi">公司简介 / Company Profile</p>
        <p class="main-news-xiao">探尔科技成立于上海，是具备自主知识产权的高新技术企业，核心团队自2013年开始在气候数字化领域深耕，具备强大的硬核技术优势。公司的核心产品“碳立方”已经在发电、建材、石化、化工和钢铁等重点控排企业，在建筑、交通和汽车、快消、服装和制药等多个工业产品领域，以及在多个地方政府落地实施，为建设中国的绿色产业贡献力量。</p>
      </div>
      <div class="main-news1" v-if="isSmallScreen===false">
        <p class="main-news-car"><span class="about">About</span> Carbon Cube</p>
        <p class="main-news-gongsi">精英团队 / Professional Team</p>
        <p class="main-news-xiao" >公司团队来自于IBM、HP等跨国企业，在气候数字化领域具备国际化的行业经验。公司研发和技术人员</p>
        <p class="main-news-xiao" >占比70%。</p>
        <p class="main-news-xiao"></p>
      </div>
      <div class="main-news1" v-else>
        <p class="main-news-car"><span class="about">About</span> Carbon Cube</p>
        <p class="main-news-gongsi">精英团队 / Professional Team</p>
        <p class="main-news-xiao" >公司团队来自于IBM、HP等跨国企业，在气候数字化领域具备国际化的行业经验。公司研发和技术人员占比70%。</p>
      </div>
      <div class="main-item">
        <button class="main-item-btn1" @click="countfrom">
          <img class="main-item-img" src="../../../assets/2023logoImage/xzjt.png" alt="">
        </button>
        <button class="main-item-btn2" @click="countto">
          <img class="main-item-img" src="../../../assets/2023logoImage/xyjt.png" alt="">
        </button>
      </div>
      <div class="main-img" v-if="isSmallScreen===false">
        <img
          class="main-img-kamran"
          src="@/assets/2023logoImage/gsjjt.png"
          alt=""
        />
      </div>
      <div class="main-img" v-else>
      </div>
      <!-- pc端 -->
      <div class="main-hezuohuoban" v-if="isSmallScreen===false">
        <div class="main-hezuohuoban-h">
          <img class="hp1" src="../../../assets/2023logoImage/hzhbz.png" alt="">
          合作伙伴 | Partners
           <img class="hp2" src="../../../assets/2023logoImage/hzhby.png" alt="">
          </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/KPMG.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/SGS.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/BUREAU VERITAS.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/Lenovo.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/klsz.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/szxx.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/shhjnyjys.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/bjlsjyhs.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/hbtpfqjyzx.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/zggjgczxyxgs1.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/zgyd.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/zgdx.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/H3C.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/jn.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/Rockwell Automation1.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/CCS1.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/hrsk.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/Schneider.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/SIEMENS.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/xgpfqjys1.png" alt="">
        </div>
      </div>
      <!-- 移动端 -->
      <div class="main-hezuohuoban" v-else>
        <div class="main-hezuohuoban-h">
          <img class="niub1" src="../../../assets/2023logoImage/hzhbz.png" alt="">
          合作伙伴 | Partners
          <img class="niub2" src="../../../assets/2023logoImage/hzhby.png" alt="">
          </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/KPMG.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/SGS.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/BUREAU VERITAS.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/Lenovo.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/klsz.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/szxx.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/shhjnyjys.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/bjlsjyhs.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/yd-hbtpfqjyzx.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/ECC.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/zgyd.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/zgdx.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/H3C.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/jn.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/Rockwell Automation1.png" alt="">
        </div>
         <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/CCS1.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/hrsk.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/Schneider.png" alt="">
        </div>
        <div class="main-image-item">
          <img class="main-image" src="@/assets/2023logoImage/SIEMENS.png" alt="">
          <img class="main-image" src="@/assets/2023logoImage/xgpfqjys1.png" alt="">
          <div class="main-image">
          </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>
export default {
  name: 'Main',
  data () {
    return {
      flag: 0,
      isSmallScreen: false,
      dialogVisible: false
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
    } else {
      this.isSmallScreen = false
    }
  },
  methods: {
    countto () {
      document.querySelector('.main-news').style.display = 'none'
      document.querySelector('.main-news1').style.display = 'block'
    },
    countfrom () {
      document.querySelector('.main-news').style.display = 'block'
      document.querySelector('.main-news1').style.display = 'none'
    }
  }
}
</script>

<style scoped lang="scss">
 .main{
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 885px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 690px;
  height: 310px;
  position: relative;
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 690px;
  height: 310px;
  position: relative;
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  font-size: 20px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  font-size: 27px;
  font-weight: 500;
  margin-top:50px ;
  margin-bottom:65px ;
}
.main-news-xiao1{
  font-size: 12px;
  margin-bottom: 30px;
}
.main-news-xiao{
  font-size: 12px;
}
.main-item-btn1{
  position: relative;
  left: 51%;
  top: -200px;
  width: 38px;
  height: 38px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 720;
  cursor: pointer !important;
}
.main-item-btn1:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-btn2{
position: relative;
left: 52%;
top: -200px;
width: 38px;
height: 38px;
z-index: 999;
background-color: #1f3135;
color: #376d66;
border: 1px solid #376d66;
border-radius: 10%;
cursor: pointer !important;
}
.main-item-btn2:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-img{
  width: 14px;
  height: 14px;
  margin: 0 auto;
}
.main-img{
  position: relative;
}
.main-img-kamran{
  position: relative;
  top: -430px;
  right: -60%;
  right: -9;
  width: 450px;
  height: 340px;
  z-index: 910;
}
.main-hezuohuoban{
  width: 100%;
  height: 952px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap ;
}
.main-hezuohuoban-h{
  font-size: 30px;
  position: relative;
  top: -280px;
  text-align: center;;
  z-index: 130;
  color: black;
}
.hp1{
  width: 112px;
  height: 9px;
  position: relative;
  left: -149px;
  top: 29px;
}
.hp2{
  width: 112px;
  height: 9px;
  position: relative;
  left: 294px;
  top: -21px;
}
.main-image-item{
  margin-top: -600px;
  margin-left:18% ;
  margin-right:16% ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 150px;
}
.main-image{
  /* width: 280px; */
  width: 240px;
  height: 120px;
}
@media screen and (max-width: 1440px) and (min-width:1000px) {
  .main{
  margin-top:0px ;
  width: 100%;
  height: 850px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 690px;
  height: 310px;
  position: relative;
  /* left: 280px; */
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 690px;
  height: 310px;
  position: relative;
  /* left: 280px; */
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  font-size: 20px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  font-size: 27px;
  font-weight: 500;
  margin-top:50px ;
  margin-bottom:65px ;
}
.main-news-xiao1{
  font-size: 12px;
  margin-bottom: 30px;
}
.main-news-xiao{
  font-size: 12px;
  margin-bottom: 10px;
}
.main-item-btn1{
  position: relative;
  left: 51%;
  top: -200px;
  width: 38px;
  height: 38px;
  background-color: #1f3135;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 720;
  cursor: pointer !important;
}
.main-item-btn1:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-btn2{
position: relative;
left: 52%;
top: -200px;
width: 38px;
height: 38px;
z-index: 999;
background-color: #1f3135;
color: #376d66;
border: 1px solid #376d66;
border-radius: 10%;
cursor: pointer !important;
}
.main-item-btn2:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-img{
  width: 14px;
  height: 14px;
  margin: 0 auto;
  filter: drop-shadow(1px 0px #376d66);
}
.main-img{
  position: relative;
}
.main-img-kamran{
  position: relative;
  top: -430px;
  right: -60%;
  width: 450px;
  height: 340px;
  z-index: 910;
}
.main-hezuohuoban{
  width: 100%;
  height: 952px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap ;
}
.main-hezuohuoban-h{
  font-size: 30px;
  position: relative;
  top: -280px;
  text-align: center;;
  z-index: 130;
  color: black;
}
.hp1{
  width: 112px;
  height: 9px;
  position: relative;
  left: -149px;
  top: 29px;
}
.hp2{
  width: 112px;
  height: 9px;
  position: relative;
  left: 294px;
  top: -21px;
}
.main-image-item{
  margin-top: -600px;
  margin-left:18% ;
  margin-right:16% ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 150px;
}
.main-image{
  width: 240px;
  height: 120px;
}
}
@media  screen and (max-width:1794px) and (min-width:1541px) {
.main{
  margin-top:-166px ;
  width: 100%;
  height: 839px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 690px;
  height: 310px;
  position: relative;
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 690px;
  height: 310px;
  position: relative;
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  font-size: 20px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  font-size: 27px;
  font-weight: 500;
  margin-top:50px ;
  margin-bottom:65px ;
}
.main-news-xiao1{
  font-size: 12px;
  margin-bottom: 30px;
}
.main-news-xiao{
  font-size: 12px;
  margin-bottom:10px ;
}
.main-item-btn1{
  position: relative;
  left: 51%;
  top: -200px;
  width: 38px;
  height: 38px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 720;
  cursor: pointer !important;
}
.main-item-btn1:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-btn2{
position: relative;
left: 52%;
top: -200px;
width: 38px;
height: 38px;
z-index: 999;
background-color: #1f3135;
color: #376d66;
border: 1px solid #376d66;
border-radius: 10%;
cursor: pointer !important;
}
.main-item-btn2:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-img{
  width: 14px;
  height: 14px;
  margin: 0 auto;
}
.main-img{
  position: relative;
}
.main-img-kamran{
  position: relative;
  top: -430px;
  right: -60%;
  right: -9;
  width: 450px;
  height: 340px;
  z-index: 910;
}
.main-hezuohuoban{
  width: 100%;
  height: 952px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap ;
}
.main-hezuohuoban-h{
  font-size: 30px;
  position: relative;
  top: -280px;
  text-align: center;;
  z-index: 130;
  color: black;
}
.hp1{
  width: 112px;
  height: 9px;
  position: relative;
  left: -149px;
  top: 29px;
}
.hp2{
  width: 112px;
  height: 9px;
  position: relative;
  left: 294px;
  top: -21px;
}
.main-image-item{
  margin-top: -600px;
  margin-left:18% ;
  margin-right:16% ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 150px;
}
.main-image{
  width: 240px;
  height: 120px;
}
}
@media  screen and (max-width:1540px) and (min-width:1441px) {
.main{
  margin-top:-207px ;
  width: 100%;
  height: 839px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 690px;
  height: 310px;
  position: relative;
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 690px;
  height: 310px;
  position: relative;
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  font-size: 20px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  font-size: 27px;
  font-weight: 500;
  margin-top:50px ;
  margin-bottom:65px ;
}
.main-news-xiao1{
  font-size: 12px;
  margin-bottom: 30px;
}
.main-news-xiao{
  font-size: 12px;
  margin-bottom:10px ;
}
.main-item-btn1{
  position: relative;
  left: 51%;
  top: -200px;
  width: 38px;
  height: 38px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 720;
  cursor: pointer !important;
}
.main-item-btn1:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-btn2{
position: relative;
left: 52%;
top: -200px;
width: 38px;
height: 38px;
z-index: 999;
background-color: #1f3135;
color: #376d66;
border: 1px solid #376d66;
border-radius: 10%;
cursor: pointer !important;
}
.main-item-btn2:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-img{
  width: 14px;
  height: 14px;
  margin: 0 auto;
}
.main-img{
  position: relative;
}
.main-img-kamran{
  position: relative;
  top: -430px;
  right: -60%;
  right: -9;
  width: 450px;
  height: 340px;
  z-index: 910;
}
.main-hezuohuoban{
  width: 100%;
  height: 952px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap ;
}
.main-hezuohuoban-h{
  font-size: 30px;
  position: relative;
  top: -280px;
  text-align: center;;
  z-index: 130;
  color: black;
}
.hp1{
  width: 112px;
  height: 9px;
  position: relative;
  left: -149px;
  top: 29px;
}
.hp2{
  width: 112px;
  height: 9px;
  position: relative;
  left: 294px;
  top: -21px;
}
.main-image-item{
  margin-top: -600px;
  margin-left:18% ;
  margin-right:16% ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 150px;
}
.main-image{
  width: 240px;
  height: 120px;
}
}
@media  screen and (max-width:1919px) and (min-width:1795px) {
   .main{
  margin-top:-60px ;
  width: 100%;
  height: 851px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 690px;
  height: 310px;
  position: relative;
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 690px;
  height: 310px;
  position: relative;
  left: 19%;
  top: 100px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  font-size: 20px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  font-size: 27px;
  font-weight: 500;
  margin-top:50px ;
  margin-bottom:65px ;
}
.main-news-xiao1{
  font-size: 14px;
  margin-bottom: 30px;
}
.main-news-xiao{
  font-size: 14px;
  margin-bottom: 10px;
}
.main-item-btn1{
  position: relative;
  left: 51%;
  top: -200px;
  width: 38px;
  height: 38px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 720;
  cursor: pointer !important;
}
.main-item-btn1:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-btn2{
position: relative;
left: 52%;
top: -200px;
width: 38px;
height: 38px;
z-index: 999;
background-color: #1f3135;
color: #376d66;
border: 1px solid #376d66;
border-radius: 10%;
cursor: pointer !important;
}
.main-item-btn2:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-img{
  width: 14px;
  height: 14px;
  margin: 0 auto;
}
.main-img{
  position: relative;
}
.main-img-kamran{
  position: relative;
  top: -430px;
  right: -60%;
  right: -9;
  width: 450px;
  height: 340px;
  z-index: 910;
}
.main-hezuohuoban{
  width: 100%;
  height: 952px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap ;
}
.main-hezuohuoban-h{
  font-size: 30px;
  position: relative;
  top: -280px;
  text-align: center;;
  z-index: 130;
  color: black;
}
.hp1{
  width: 112px;
  height: 9px;
  position: relative;
  left: -149px;
  top: 29px;
}
.hp2{
  width: 112px;
  height: 9px;
  position: relative;
  left: 294px;
  top: -21px;
}
.main-image-item{
  margin-top: -600px;
  margin-left:18% ;
  margin-right:16% ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 150px;
}
.main-image{
  /* width: 280px; */
  width: 240px;
  height: 120px;
}
}
@media screen and (min-width: 1920px) {
.main{
  margin-top: -281px;
  width: 100%;
  height: 930px;
    background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 690px;
  height: 310px;
  position: relative;
  left: 360px;
  top: 100px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 690px;
  height: 310px;
  position: relative;
  left: 360px;
  top: 100px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  font-size: 22px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  font-size: 27px;
  font-weight: 500;
  margin-top:50px ;
  margin-bottom:65px ;
}
.main-news-xiao1{
  font-size: 16px;
  margin-bottom: 30px;
}
.main-news-xiao{
  display: inline-block;
  width: 772px;
  font-size: 16px;
  margin-bottom: 10px;
}
.main-item-btn1{
  position: relative;
  left: 1080px;
  top: -200px;
  width: 38px;
  height: 38px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
  cursor: pointer !important;
}
.main-item-btn1:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-btn2{
position: relative;
left: 1090px;
top: -200px;
width: 38px;
height: 38px;
z-index: 999;
background-color: #1f3135;
color: #376d66;
border: 1px solid #376d66;
border-radius: 10%;
cursor: pointer !important;
}

.main-item-btn2:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-img{
  width: 14px;
  height: 14px;
  margin: 0 auto;
  filter: drop-shadow(1px 0px #376d66);
}
.main-img{
  width: 600px;
  height: 400px;
  position: relative;
}
.main-img-kamran{
  text-align: right;
  position: relative;
  top: -450px;
  left: 200%;
  width: 550px;
  height: 440px;
  z-index: 110;
}
.main-hezuohuoban{
  width: 100%;
  height: 952px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap ;
}
.main-hezuohuoban-h{
  font-size: 30px;
  position: relative;
  top: -280px;
  text-align: center;;
  z-index: 130;
  color: black;
}
.hp1{
  width: 112px;
  height: 9px;
  position: relative;
  left: -149px;
  top: 29px;
}
.hp2{
  width: 112px;
  height: 9px;
  position: relative;
  left: 294px;
  top: -21px;
}
.main-image-item{
  margin-top: -600px;
  margin-left:18% ;
  margin-right:16% ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 150px;
}
.main-image{
  width: 280px;
  height: 120px;
}
}
@media screen and (min-width: 2155.5px) {
.main{
  margin-top: -182px;
  width: 100%;
  height: 930px;
    background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 690px;
  height: 310px;
  position: relative;
  left: 360px;
  top: 100px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 690px;
  height: 310px;
  position: relative;
  left: 360px;
  top: 100px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  font-size: 22px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  font-size: 27px;
  font-weight: 500;
  margin-top:50px ;
  margin-bottom:65px ;
}
.main-news-xiao1{
  font-size: 16px;
  margin-bottom: 30px;
}
.main-news-xiao{
  font-size: 16px;
}
.main-item-btn1{
  position: relative;
  left: 1080px;
  top: -200px;
  width: 38px;
  height: 38px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
  cursor: pointer !important;
}
.main-item-btn1:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-btn2{
position: relative;
left: 1090px;
top: -200px;
width: 38px;
height: 38px;
z-index: 999;
background-color: #1f3135;
color: #376d66;
border: 1px solid #376d66;
border-radius: 10%;
cursor: pointer !important;
}
.main-item-btn2:hover {
background-color: #7efbde;
border: 1px solid #7efbde;
border-width: 2px;
transition: all 0.7s ease-in-out;
}
.main-item-img{
  width: 14px;
  height: 14px;
  margin: 0 auto;
  filter: drop-shadow(1px 0px #376d66);
}
.main-img{
  width: 600px;
  height: 400px;
  position: relative;
}
.main-img-kamran{
  text-align: right;
  position: relative;
  top: -450px;
  left: 200%;
  width: 550px;
  height: 440px;
  z-index: 110;
}
.main-hezuohuoban{
  width: 100%;
  height: 952px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap ;
}
.main-hezuohuoban-h{
  font-size: 30px;
  position: relative;
  top: -280px;
  text-align: center;;
  z-index: 130;
  color: black;
}
.hp1{
  width: 112px;
  height: 9px;
  position: relative;
  left: -149px;
  top: 29px;
}
.hp2{
  width: 112px;
  height: 9px;
  position: relative;
  left: 294px;
  top: -21px;
}
.main-image-item{
  margin-top: -600px;
  margin-left:18% ;
  margin-right:16% ;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 150px;
}
.main-image{
  width: 280px;
  height: 120px;
}
}
@media screen and (max-width: 360px) {
.main{
  // margin-top:-543px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  left: 265px;
  top: -255px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  left: 275px;
  top: -255px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 10px;
  height: 10px;
}
.main-img-kamran{
  position: relative;
  top: -373px;
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:245px;
  /* height: 348px; */
  height: 420px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  /* margin-top: -546px; */
  margin-top: -606px;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 96px;
  height: 45px;
  margin-top: 20px;
}
}
@media screen and (max-width: 375px) and (min-width: 361px) {
.main{
  // margin-top:-533px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  left: 265px;
  top: -255px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  left: 275px;
  top: -255px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 10px;
  height: 10px;
}
.main-img-kamran{
  position: relative;
  top: -373px;
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:255px;
  /* height: 348px; */
  height: 451px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  /* margin-top: -546px; */
  margin-top: -606px ;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 96px;
  height: 45px;
  margin-top: 20px;
}
}
@media screen and (max-width: 393px) and (min-width:391px) {
.main{
  // margin-top:-519px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  /* height: 310px; */
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  /* margin-left: 10px; */
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  /* right: -1050px; */
  left: 309px;
  top: -280px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  /* right: -1060px; */
  left: 315px;
  top: -280px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 15px;
  height: 15px;
}
.main-img-kamran{
  /* text-align: right; */
  position: relative;
  top: -373px;
  /* right: -200%; */
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:258px;
  /* height: 371px; */
  height: 478px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  /* margin-top: -546px; */
  margin-top:-616px ;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 107px;
  height: 52px;
  margin-top: 20px;
}
}
@media screen and (max-width: 414px) and (min-width:394px) {
.main{
  // margin-top:-505px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  /* height: 310px; */
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  /* margin-left: 10px; */
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  /* right: -1050px; */
  left: 309px;
  top: -280px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  /* right: -1060px; */
  left: 315px;
  top: -280px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 15px;
  height: 15px;
}
.main-img-kamran{
  /* text-align: right; */
  position: relative;
  top: -373px;
  /* right: -200%; */
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:258px;
  /* height: 371px; */
  height: 478px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  /* margin-top: -546px; */
  margin-top: -616px;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  /* width: 83px;
  height: 39px; */
  width: 107px;
  height: 52px;
  margin-top: 20px;
}
}
@media screen and (max-width: 500px) and (min-width:415px) {
.main{
  // margin-top:-499px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  /* height: 310px; */
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  /* margin-left: 10px; */
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  /* right: -1050px; */
  left: 309px;
  top: -280px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  /* right: -1060px; */
  left: 315px;
  top: -280px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 15px;
  height: 15px;
}
.main-img-kamran{
  /* text-align: right; */
  position: relative;
  top: -373px;
  /* right: -200%; */
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:258px;
  height: 371px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  margin-top: -546px;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 83px;
  height: 39px;
  margin-top: 20px;
}
}
@media screen and (max-width: 567px) and (min-width:501px) {
.main{
  // margin-top:-438px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  /* height: 310px; */
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  /* margin-left: 10px; */
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  /* right: -1050px; */
  left: 309px;
  top: -280px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  /* right: -1060px; */
  left: 315px;
  top: -280px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 15px;
  height: 15px;
}
.main-img-kamran{
  /* text-align: right; */
  position: relative;
  top: -373px;
  /* right: -200%; */
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:258px;
  height: 371px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  margin-top: -546px;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 83px;
  height: 39px;
  margin-top: 20px;
}
}
@media screen and (max-width: 600px) and (min-width:568px) {
.main{
  // margin-top:-398px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  /* height: 310px; */
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  /* margin-left: 10px; */
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  /* right: -1050px; */
  left: 309px;
  top: -280px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  /* right: -1060px; */
  left: 315px;
  top: -280px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 15px;
  height: 15px;
}
.main-img-kamran{
  /* text-align: right; */
  position: relative;
  top: -373px;
  /* right: -200%; */
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:258px;
  height: 371px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  margin-top: -546px;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 83px;
  height: 39px;
  margin-top: 20px;
}
}
@media screen and (max-width: 660px) and (min-width:601px) {
.main{
  // margin-top:-373px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  /* height: 310px; */
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  /* margin-left: 10px; */
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  /* right: -1050px; */
  left: 309px;
  top: -280px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  /* right: -1060px; */
  left: 315px;
  top: -280px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 15px;
  height: 15px;
}
.main-img-kamran{
  /* text-align: right; */
  position: relative;
  top: -373px;
  /* right: -200%; */
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:258px;
  height: 371px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  margin-top: -546px;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 83px;
  height: 39px;
  margin-top: 20px;
}
}
@media screen and (max-width: 1000px) and (min-width:768px) {
.main{
  // margin-top:-251px ;
  width: 100%;
  height: 885px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 690px;
  height: 310px;
  position: relative;
  /* left: 280px; */
  left: 5%;
  top: 100px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 690px;
  height: 310px;
  position: relative;
  /* left: 280px; */
  left: 5%;
  top: 100px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  font-size: 20px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  color: #376d66;
}
.main-news-gongsi{
  font-size: 27px;
  font-weight: 500;
  margin-top:50px ;
  margin-bottom:65px ;
}
.main-news-xiao1{
  font-size: 14px;
  margin-bottom: 30px;
}
.main-news-xiao{
  font-size: 14px;
  line-height: 25px;
}
.main-item-btn1{
  position: relative;
  left: 79%;
  top: -200px;
  width: 38px;
  height: 38px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 720;
}
.main-item-btn1:hover{
  background-color: #7efbde;
}
.main-item-btn2{
position: relative;
left: 81%;
top: -200px;
width: 38px;
height: 38px;
z-index: 999;
background-color: #1f3135;
color: #376d66;
border: 1px solid #376d66;
border-radius: 10%;
}
.main-item-btn2:hover{
  background-color: #7efbde;
}
.main-item-img{
  width: 25px;
  height: 25px;
  margin: 0 auto;
  filter: drop-shadow(1px 0px #376d66);
}
.main-img{
  position: relative;
}
.main-img-kamran{
  position: relative;
  top: -430px;
  right: -60%;
  right: -9;
  width: 150px;
  height: 140px;
  z-index: 910;
}
.main-hezuohuoban{
  margin-top:348px ;
  width: 100%;
  height: 952px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap ;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  z-index: 130;
  color: black;
}
.niub1{
  width: 112px;
  height: 9px;
  position: relative;
  left: -149px;
  top: 29px;
}
.niub2{
  width: 112px;
  height: 9px;
  position: relative;
  left: 294px;
  top: -21px;
}
.main-image-item{
  margin-top: -600px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px;
}
.main-image{
  width: 238px;
  /* height: 98px; */
}
}
@media screen and (max-width: 390px) and (min-width:376px) {
.main{
  // margin-top:-522px;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  /* margin-left: 10px; */
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  /* right: -1050px; */
  left: 309px;
  top: -280px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  left: 315px;
  top: -280px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 15px;
  height: 15px;
}
.main-img-kamran{
  position: relative;
  top: -373px;
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:258px;
  /* height: 371px; */
  height: 478px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 203px;
  top: -17px;
}
.main-image-item{
  /* margin-top: -546px; */
  margin-top: -616px ;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 107px;
  height: 52px;
  margin-top: 20px;
}
}
@media screen and (max-width: 767px) and (min-width:661px) {
.main{
  // margin-top:-283px ;
  width: 100%;
  height: 585px;
  background-image: linear-gradient(172deg, #1f3135 50%, transparent 50%);
}
.main-news{
  width: 100%;
  /* height: 310px; */
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
}
.main-news1{
  width: 100%;
  height: 310px;
  text-align: left;
  position: relative;
  left: 50%;
  transform: translate(-50%);
  top: 30px;
  color: white;
  z-index: 109;
  display: none;
}
.main-news-car{
  margin-left: 10px;
  font-size: 10px;
  font-weight: 500;
  color: #7efbde;
}
.about{
  /* margin-left: 10px; */
  color: #376d66;
}
.main-news-gongsi{
  margin-left: 10px;
  margin-right: 10px ;
  font-size: 15px;
  font-weight: 500;
  margin-top:20px ;
  margin-bottom:15px ;
}
.main-news-xiao1{
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
  margin-bottom: 20px;
}
.main-news-xiao{
  line-height: 20px;
  margin-right:10px ;
  margin-left: 10px;
  font-size: 12px;
}
.main-item-btn1{
   position: relative;
  /* right: -1050px; */
  left: 309px;
  top: -280px;
  width: 30px;
  height: 30px;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
  z-index: 120;
}
.main-item-btn2{
  position: relative;
  /* right: -1060px; */
  left: 315px;
  top: -280px;
  width: 30px;
  height: 30px;
  z-index: 999;
  background-color: #1f3135;
  color: #376d66;
  border: 1px solid #376d66;
  border-radius: 10%;
}
.main-item-img{
  width: 15px;
  height: 15px;
}
.main-img-kamran{
  /* text-align: right; */
  position: relative;
  top: -373px;
  /* right: -200%; */
  left: 59%;
  width: 130px;
  height: 110px;
  z-index: 110;
}
.main-hezuohuoban{
  text-align: center;
  margin-top:258px;
  height: 371px;
}
.main-hezuohuoban-h{
  position: relative;
  top: -280px;
  text-align: center;;
  font-size: 20px;
  z-index: 130;
  color: black;
}
.niub1{
  width: 50px;
  height: 4px;
  position: relative;
  left: -69px;
  top: 19px;
}
.niub2{
  width: 50px;
  height: 4px;
  position: relative;
  left: 197px;
  top: -14px;
}
.main-image-item{
  margin-top: -546px;
  margin-left:20px ;
  margin-right:20px ;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  flex-direction: row;
  flex-wrap: wrap ;
  width: 100%;
  height: 50px;
}
.main-image{
  width: 83px;
  height: 39px;
  margin-top: 20px;
}
}
</style>
